import breakPoints from "helpers/Styles";
import Link from "next/link";
import React, { useState } from "react";

const JobsBlock = ({ block }) => {
  if (!block) return "";
  const { items } = block;

  const [selectedCountry, setSelectedCountry] = useState("Singapore");
  const [selectedType, setSelectedType] = useState("full time");

  const handleSelectedCountry = (event) => {
    setSelectedCountry(event.target.value);
  };
  const handleSelectedType = (event) => {
    setSelectedType(event.target.value);
  };

  const jobResults =
    items &&
    items?.filter(
      (item) =>
        item?.selected_country === selectedCountry &&
        item?.selected_job_type === selectedType
    );

  return (
    <div className="wrapper block_container">
      <h1 className="block_title">JOB OPENINGS</h1>
      <div className="selected_container">
        <div className="container">
          <select value={selectedCountry} onChange={handleSelectedCountry}>
            <option value="Australia" selected>
              Australia
            </option>
            <option value="Singapore">Singapore</option>
          </select>
        </div>
        <div className="container">
          <select value={selectedType} onChange={handleSelectedType}>
            <option value="full time">Full time</option>
            <option value="part time">Part time</option>
          </select>
        </div>
      </div>

      <div className="job_titles">
        <div>
          <h3>JOB TITLE</h3>
        </div>
        <div>
          <h3>LOCATION</h3>
        </div>
        <div>
          <h3>POSITION TYPE</h3>
        </div>
        <div>
          <h3>EXPERIENCE</h3>
        </div>
        <div></div>
      </div>

      <div>
        {jobResults &&
          jobResults.map((item) => {
            const jobTitle = item?.job_title;
            const jobLocation = item?.location;
            const jobType = item?.position_type;
            const jobExperience = item?.experience;
            const applyTitle = item?.button_contents;

            const jobLink = item?.job_details_page?.uid?.replace('aux-', '');

            return (
              <>
                <div className="job_details">
                  <div>{jobTitle}</div>
                  <div>{jobLocation}</div>
                  <div>{jobType}</div>
                  <div>{jobExperience}</div>
                  <div>
                    <Link href={`/pages/${jobLink}` || '/careers'}>
                      <a
                        href={`/pages/${jobLink}` || '/careers'}
                        className="apply"
                      >
                        {applyTitle}
                      </a>
                    </Link>
                  </div>
                </div>
                <div className="job_details_mobile">
                  <div className="container">
                    <div>
                      <h3>JOB TITLE</h3>
                    </div>
                    <div className="detail">{jobTitle}</div>
                  </div>
                  <div className="container">
                    <div>
                      <h3>LOCATION</h3>
                    </div>
                    <div className="detail">{jobLocation}</div>
                  </div>
                  <div className="container">
                    <div>
                      <h3>POSITION TYPE</h3>
                    </div>
                    <div className="detail">{jobType}</div>
                  </div>
                  <div className="container">
                    <div>
                      <h3>EXPERIENCE</h3>
                    </div>
                    <div className="detail">{jobExperience}</div>
                  </div>

                  <div>
                    <Link href={`/pages/${jobLink}` || '/careers'}>
                      <a
                        href={`/pages/${jobLink}` || '/careers'}
                        className="apply"
                      >
                        {applyTitle}
                      </a>
                    </Link>
                  </div>
                </div>
              </>
            );
          })}
      </div>

      <style jsx>
        {`
          .block_container {
            margin-bottom: 50px;
            margin-top: 50px;
          }
          .block_title {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
            text-align: center;
          }
          .selected_container {
            display: flex;
            justify-content: center;
            gap: 32px;
            margin-bottom: 64px;
            margin-top: 46px;
          }
          .job_titles {
            display: grid;
            grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr;
            border-bottom: 1px solid #242424;
          }
          .job_titles h3,
          .job_details_mobile h3 {
            color: #949494;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
          }
          .job_details {
            padding: 32px 0;
            display: grid;
            grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
            border-bottom: 1px solid #242424;
            gap: 10px;
          }
          .job_details_mobile {
            display: none;
          }
          .apply {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40px;
            width: 198px;
            border-radius: 2px;
            background-color: #950810;
            outline: none;
            border: 0px;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            text-transform: uppercase;
            cursor: pointer;
          }
          .apply:hover {
            background-color: #800006;
          }
          select {
            box-sizing: border-box;
            height: 48px;
            width: 312px;
            border: 1px solid #242424;
            border-radius: 2px;
            background-color: #141414;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            outline: none;
            cursor: pointer;
            padding: 14px;
          }

          @media (max-width: ${breakPoints.small}) {
            .selected_container .container {
              display: flex;
              justify-content: center;
            }
            .job_titles {
              display: none;
            }
            select {
              width: 90%;
              margin-top: 20px;
            }
            .selected_container {
              display: block;
              margin-bottom: 50px;
              margin-top: 20px;
            }
            .apply {
              width: 90%;
              margin: 0 auto;
            }
            .job_details_mobile {
              display: block;
              margin-bottom: 40px;
            }
            .job_details_mobile .container {
              display: grid;
              grid-template-columns: 1fr 1.5fr;
              width: 90%;
              margin: 0 auto;
            }
            .job_details {
              display: none;
            }
            .detail {
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }
          }
        `}
      </style>
    </div>
  );
};

export default JobsBlock;
